export default "/assets/images/column-image9.4308f2c7e2d29f5f.jpg";